<div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [labels]="chartOptions.labels"
      [responsive]="chartOptions.responsive"
      [fill]="chartOptions.fill"
      [title]="chartOptions.title"
      [legend]="chartOptions.legend"
      [tooltip]="chartOptions.tooltip"
    ></apx-chart>
</div>